import { render, staticRenderFns } from "./dropdowns.vue?vue&type=template&id=481b743a&"
import script from "./dropdowns.vue?vue&type=script&lang=js&"
export * from "./dropdowns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports